import { render, staticRenderFns } from "./leftNav-text-img.vue?vue&type=template&id=39b739e8&scoped=true"
import script from "./leftNav-text-img.vue?vue&type=script&lang=js"
export * from "./leftNav-text-img.vue?vue&type=script&lang=js"
import style0 from "./leftNav-text-img.vue?vue&type=style&index=0&id=39b739e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b739e8",
  null
  
)

export default component.exports